// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.weak-set.of.js
// module id = BOYP
// module chunks = 25